/** A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. */

/**
 * Returns a padded domain maximum for charts anchored at zero.
 * If every numeric value is zero, returns a fallback max so the baseline stays at the bottom.
 *
 * @param {Array<number | null | undefined>} values
 * @param {{
 *   emptyFallback?: number;
 *   allZeroFallback?: number;
 *   paddingMultiplier?: number;
 * }} [options]
 * @returns {number}
 */
export function getDomainMax(values, options = {}) {
  const { emptyFallback = 1, allZeroFallback = emptyFallback, paddingMultiplier = 1.2 } = options;

  const numericValues = values.reduce(
    /**
     * @param {number[]} acc
     * @param {number | null | undefined} value
     */
    (acc, value) => {
      if (typeof value === "number" && !Number.isNaN(value)) {
        acc.push(value);
      }
      return acc;
    },
    /** @type {number[]} */ ([])
  );
  if (numericValues.length === 0) return emptyFallback;

  const maxValue = Math.max(...numericValues);
  if (maxValue === 0) return allZeroFallback;

  return maxValue * paddingMultiplier;
}
